/* Flooring Surgeons – legal policy pages (/policies/*). Loaded only there (snippets/fs-policy.liquid).
   Progressive enhancement over Shopify's own policy markup:
   1. ids on the policy's h2/h3 headings (stable slugs, so clauses can be linked: /policies/terms-of-service#7-providing-the-products)
   2. a table of contents when the policy is long (4+ headings): sticky rail from 1100px, collapsible "Contents" box below
   3. the "Questions about this policy?" band moved under the policy text, with a Print / save as PDF button
   Without JS the page is still complete: the policy text, and the help band above it. */
(() => {
  const box = document.querySelector('.shopify-policy__container');
  const rte = box && box.querySelector('.shopify-policy__body .rte');
  if (!box || !rte) return;

  const body = box.querySelector('.shopify-policy__body');
  const help = document.getElementById('FsPolicyHelp');
  if (help) {
    box.appendChild(help);
    const print = help.querySelector('[data-fs-policy-print]');
    if (print && typeof window.print === 'function') {
      print.hidden = false;
      print.addEventListener('click', () => window.print());
    }
  }

  /* legal lists: when every item starts with its own label – (a), (b), 7.11.1 – drop the bullet */
  rte.querySelectorAll('ul').forEach((ul) => {
    const items = [...ul.children];
    if (items.length && items.every((li) => /^\s*(\([a-z0-9]{1,4}\)|\d+(\.\d+)+)\s/i.test(li.textContent))) {
      ul.classList.add('fs-policy-list--labelled');
    }
  });

  /* 1. ids */
  const used = new Set([...document.querySelectorAll('[id]')].map((el) => el.id));
  const slug = (text) => {
    const base = text.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'section';
    let id = base; let n = 2;
    while (used.has(id)) id = `${base}-${n++}`;
    used.add(id);
    return id;
  };
  const heads = [...rte.querySelectorAll('h2, h3')].filter((h) => h.textContent.trim());
  heads.forEach((h) => { if (!h.id) h.id = slug(h.textContent.trim()); });

  /* 2. contents: the h2s are the entries (privacy, refund, shipping). Only when there are too few h2s for a useful
        contents list but several h3s (the terms: 2 parts, numbered clauses as h3) do the h3s become the entries,
        with the h2s as group labels */
  const h2s = heads.filter((h) => h.tagName === 'H2');
  const h3s = heads.filter((h) => h.tagName === 'H3');
  const useH3 = h2s.length < 4 && h3s.length >= 3;
  const entries = useH3 ? heads : heads.filter((h) => h.tagName === 'H2');
  const links = entries.filter((h) => !useH3 || h.tagName === 'H3');
  if (links.length < 4) return;

  const buildList = () => {
    const ol = document.createElement('ol');
    ol.className = 'fs-policy-toc__list';
    entries.forEach((h) => {
      const li = document.createElement('li');
      if (useH3 && h.tagName === 'H2') {
        li.className = 'fs-policy-toc__group';
        li.textContent = h.textContent.trim();
        li.setAttribute('role', 'presentation');
      } else {
        const a = document.createElement('a');
        a.href = `#${h.id}`;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
      }
      ol.appendChild(li);
    });
    return ol;
  };

  const rail = document.createElement('nav');
  rail.className = 'fs-policy-toc';
  rail.setAttribute('aria-label', 'Contents');
  const label = document.createElement('p');
  label.className = 'fs-policy-toc__label';
  label.textContent = 'Contents';
  rail.append(label, buildList());
  box.insertBefore(rail, body);

  const details = document.createElement('details');
  details.className = 'fs-policy-toc-m';
  details.innerHTML = '<summary>Contents <span class="fs-policy-toc-m__n"></span></summary>';
  details.querySelector('.fs-policy-toc-m__n').textContent = `${links.length} sections`;
  const nav = document.createElement('nav');
  nav.setAttribute('aria-label', 'Contents');
  nav.appendChild(buildList());
  details.appendChild(nav);
  const first = rte.querySelector(':scope > p:first-child');
  rte.insertBefore(details, first && /last updated/i.test(first.textContent) ? first.nextSibling : rte.firstChild);
  details.addEventListener('click', (e) => { if (e.target.closest('a')) details.open = false; });

  box.classList.add('fs-policy--toc');

  /* current section in the rail */
  if (!('IntersectionObserver' in window)) return;
  const railLinks = new Map([...rail.querySelectorAll('a')].map((a) => [a.hash.slice(1), a]));
  let current = null;
  const io = new IntersectionObserver((items) => {
    items.forEach((it) => {
      if (!it.isIntersecting) return;
      const a = railLinks.get(it.target.id);
      if (!a || a === current) return;
      if (current) current.removeAttribute('aria-current');
      a.setAttribute('aria-current', 'true');
      current = a;
    });
  }, { rootMargin: '0px 0px -70% 0px' });
  links.forEach((h) => io.observe(h));
})();
